import { useNavigate } from "react-router-dom";
import { Icon } from "../components/Icon";
import { usePageMeta } from "../hooks/usePageMeta";
import { useLanguage } from "../context/LanguageContext";

/**
 * Where a wrong URL lands.
 *
 * This used to be an inline `<p>Page not found</p>` in the route table: grey text on
 * a white page, no header, no navigation, nothing to press. Anyone who mistyped a
 * URL, followed an old link, or opened a bookmark to a page that has since been
 * removed had no way out but the back button.
 *
 * That stopped being hypothetical when /cars was deleted — a legacy list nothing
 * linked to, but a URL somebody may still have saved. Removing a page is only half
 * the job; the other half is catching the people who arrive at it afterwards.
 */
export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  usePageMeta("Page not found | Sramika");

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center">
      <div className="w-14 h-14 rounded-full bg-[#F6FAEC] flex items-center justify-center mb-4">
        <Icon name="search" size={24} stroke="#7BAE00" strokeWidth={2} />
      </div>

      <h1 className="text-[16px] font-extrabold text-[#1A1A2E]">{t("st_nfTitle")}</h1>
      <p className="text-[12px] text-[#6B7280] mt-1.5 max-w-[280px] leading-relaxed">
        {t("st_nfText")}
      </p>

      <div className="flex flex-col sm:flex-row gap-2 mt-5 w-full max-w-[280px]">
        <button
          type="button"
          onClick={() => navigate("/")}
          className="btn-primary flex-1 justify-center min-h-[44px] text-[12px]"
        >
          {t("st_nfCar")}
        </button>
        <button
          type="button"
          onClick={() => navigate("/drivers")}
          className="flex-1 flex items-center justify-center min-h-[44px] text-[12px] font-bold rounded-lg border border-[#E5E7EB] text-[#1A1A2E]"
        >
          {t("st_nfDriver")}
        </button>
      </div>
    </div>
  );
}
